export const PostCodeAddressType = {
  None: 0,
  Address: 1,
  Postcode: 2,
};

export const mapStringToAddressType = addressType => {
  switch (addressType) {
    case 'Address':
      return PostCodeAddressType.Address;
    case 'Postcode':
      return PostCodeAddressType.Postcode;
    default:
      return PostCodeAddressType.None;
  }
};
